// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"HomeFeed-62abfeb2c6454170"};